import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [

  {
    id: "avatars",
    title: "Users",
    translate: "MENU.DASHBOARD.users",
    type: "collapsible",
    icon: "users",
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "users",
      },
      // {
      //   id: "avatars-add",
      //   title: "Add",
      //   translate: "MENU.DASHBOARD.add",
      //   type: "item",
      //   icon: "circle",
      //   url: "users-add",
      // },
    ],
  },
  // {
  //   id: "avatars",
  //   title: "missed prayers",
  //   translate:  "MENU.DASHBOARD.MISSED_PRAYERS",
  //   type: "collapsible" ,
  //   icon: "tablet", 
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "missed-prayers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-ads",
  //     },
  //   ],
  // },
  {
    id: "avatars",
    title: " Notifications",
    translate:  "MENU.DASHBOARD.NOTIFICATIONS",
    type: "collapsible" ,
    icon: "bell", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "z-notifications",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "z-add-notifications",
      },
    ],
  },
  {
    id: "avatars",
    title: "Categories",
    translate:  "MENU.DASHBOARD.categories",
    type: "collapsible" ,
    icon: "layers", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "categories",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-categories",
      },
    ],
  },


  {
    id: "avatars",
    title: " daily_users",
    translate:  "MENU.DASHBOARD.daily_users",
    type: "collapsible" ,
    icon: "users", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "DAILY_USERS",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-DAILY_USERS",
      },
    ],
  },
  // {
  //   id: "avatars",
  //   title: " daily users",
  //   translate:  "MENU.DASHBOARD.prayer_makeup",
  //   type: "collapsible" ,
  //   icon: "clock", 
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "PRAYER_MAKEUP",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-categories",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: " daily users",
  //   translate:  "MENU.DASHBOARD.participation_engagement",
  //   type: "collapsible" ,
  //   icon: "activity", 
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "PARTICIPATION_ENGAGEMENT",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-categories",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: " daily users",
  //   translate:  "MENU.DASHBOARD.zakat",
  //   type: "collapsible" ,
  //   icon: "credit-card", 
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "ZAKAT",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-categories",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: " daily users",
  //   translate:  "MENU.DASHBOARD.ramadan_missed",
  //   type: "collapsible" ,
  //   icon: "calendar", 
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "RAMADAN_MISSED_FASTS",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-categories",
  //     },
  //   ],
  // },
  {
    id: "avatars",
    title: " fatwa",
    translate:  "MENU.DASHBOARD.fatwa",
    type: "collapsible" ,
    icon: "file-text", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "FATWA",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-FATWA",
      },
    ],
  },
  {
    id: "avatars",
    title: " fiqh",
    translate:  "MENU.DASHBOARD.fiqh",
    type: "collapsible" ,
    icon: "book-open", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "FIQH",
      },
            {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-FIQH",
      },
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.LESSONS",
        type: "item",
        icon: "book",
        url: "lessons",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-lessons",
      },
    ],
  },
  {
    id: "avatars",
    title: " religious_inquiries",
    translate:  "MENU.DASHBOARD.religious_inquiries",
    type: "collapsible" ,
    icon: "help-circle", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "ASK_MUFTI",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-ASK_MUFTI",
      },
    ],
  },


  {
    id: "avatars",
    title: " items",
    translate:  "MENU.DASHBOARD.items",
    type: "collapsible" ,
    icon: "box", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "items",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "add-items",
      },
    ],
  },
  {
    id: "avatars",
    title: " Social Links",
    translate:  "MENU.DASHBOARD.SOCIAL_LINKS",
    type: "collapsible" ,
    icon: "link", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "z-social-links",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "z-add-social-links",
      },
    ],
  },
  {
    id: "avatars",
    title: "On Boarding ",
    translate:  "MENU.DASHBOARD.TITLEE",
    type: "collapsible" ,
    icon: "user-check", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "z-on-boarding",
      },
      {
        id: "avatars-add",
        title: "Add",
        translate: "MENU.DASHBOARD.add",
        type: "item",
        icon: "circle",
        url: "z-add-on-boarding",
      },
    ],
  },
  {
    id: "avatars",
    title: "z-privacy-policy ",
    translate:  "MENU.DASHBOARD.PRIVACY_POLICY",
    type: "collapsible" ,
    icon: "shield", 
    children: [
      {
        id: "avatars-list",
        title: "List",
        translate: "MENU.DASHBOARD.list",
        type: "item",
        icon: "circle",
        url: "z-privacy-policy",
      },
      // {
      //   id: "avatars-add",
      //   title: "Add",
      //   translate: "MENU.DASHBOARD.add",
      //   type: "item",
      //   icon: "circle",
      //   url: "add-ads",
      // },
    ],
  },
  // {
  //   id: "avatars",
  //   title: "Counselors",
  //   translate:  "MENU.DASHBOARD.counselors",
  //   type: "collapsible",
  //   icon: "package",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "Stores",
  //       type: "item",
  //       icon: "circle",
  //       url: "counselors",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "add-counselors",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Stores Offers",
  //   translate:  "MENU.DASHBOARD.stores_offers",
  //   type: "collapsible",
  //   icon: "dollar-sign",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "Vouchers",
  //       type: "item",
  //       icon: "circle",
  //       url: "StoresOffers-Vouchers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "StoresOffers-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Cancelation Reason",
  //   translate:  "MENU.DASHBOARD.cancelation_reason",
  //   type: "collapsible",
  //   icon: "tablet",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "CancelationReasons",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "CancelationReasons-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Companies",
  //   translate:  "MENU.DASHBOARD.companies",
  //   type: "collapsible",
  //   icon: "hexagon",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Companies",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Companies-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Consulting",
  //   translate:  "MENU.DASHBOARD.consulting",
  //   type: "collapsible",
  //   icon: "credit-card",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Consulting",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Consulting-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Categories",
  //   translate:  "MENU.DASHBOARD.categories",
  //   type: "collapsible",
  //   icon: "percent",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Categories",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Categories-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Services",
  //   translate:  "MENU.DASHBOARD.services",
  //   type: "collapsible",
  //   icon: "map-pin",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Services",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Services-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Tags",
  //   translate:  "MENU.DASHBOARD.tags",
  //   type: "collapsible",
  //   icon: "video",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Tags",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Tags-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Articles",
  //   translate:  "MENU.DASHBOARD.articles",
  //   type: "collapsible",
  //   icon: "upload",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Articles",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Articles-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Offers",
  //   translate: "MENU.DASHBOARD.offers",
  //   type: "collapsible",
  //   icon: "settings",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "Offers",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "Offers-add",
  //     },
  //   ],
  // },
  // {
  //   id: "avatars",
  //   title: "Plant Cards",
  //   translate:  "MENU.DASHBOARD.plantcards",
  //   type: "collapsible",
  //   icon: "flag",
  //   children: [
  //     {
  //       id: "avatars-list",
  //       title: "List",
  //       translate: "MENU.DASHBOARD.list",
  //       type: "item",
  //       icon: "circle",
  //       url: "planetCards",
  //     },
  //     {
  //       id: "avatars-add",
  //       title: "Add",
  //       translate: "MENU.DASHBOARD.add",
  //       type: "item",
  //       icon: "circle",
  //       url: "planetCards-add",
  //     },
  //   ],
  // },
 
  // {
  //   id: "settings",
  //   title: "Settings",
  //   translate: "MENU.DASHBOARD.Settings",
  //   type: "collapsible", // Allows the menu to be clickable and expandable
  //   icon: "help-circle",
  //   children: [
  //     {
  //       id: "show-details",
  //       title: "Show Details",
  //       translate: "MENU.DASHBOARD.ShowDetails",
  //       type: "item",
  //       icon: "circle",
  //       url: "settings",
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Terms & Conditions",
  //       translate: "MENU.DASHBOARD.TermsAndConditions",
  //       type: "collapsible", // Expandable item with children
  //       icon: "lock",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "terms-conditions",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "About",
  //       translate: "MENU.DASHBOARD.About",
  //       type: "collapsible", // Expandable item with children
  //       icon: "file-text",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "about",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Notifications",
  //       translate: "MENU.DASHBOARD.Notifications",
  //       type: "collapsible", // Expandable item with children
  //       icon: "shuffle",
  //       children: [
  //         {
  //           id: "terms-show-details",
  //           title: "Show Details",
  //           translate: "MENU.DASHBOARD.ShowDetails",
  //           type: "item",
  //           icon: "circle",
  //           url: "Notifications",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Currencies",
  //       translate: "MENU.DASHBOARD.Currencies",
  //       type: "collapsible", // Expandable item with children
  //       icon: "package",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "currencies",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "curriences-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Countries",
  //       translate: "MENU.DASHBOARD.Countries",
  //       type: "collapsible", // Expandable item with children
  //       icon: "gift",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "countries",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "countries-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Cities",
  //       translate: "MENU.DASHBOARD.Cities",
  //       type: "collapsible", // Expandable item with children
  //       icon: "grid",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "cities",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "cities-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.plans",
  //       translate: "MENU.DASHBOARD.plans",
  //       type: "collapsible", // Expandable item with children
  //       icon: "calendar",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "plans",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languagePlans-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Open Screens",
  //       translate: "MENU.DASHBOARD.OpenScreens",
  //       type: "collapsible", // Expandable item with children
  //       icon: "video",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "open-screen",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "openScreens-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.light",
  //       translate: "MENU.DASHBOARD.light",
  //       type: "collapsible", // Expandable item with children
  //       icon: "list",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "light",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageLight-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Ganatak community",
  //       translate: "MENU.DASHBOARD.GanatakCommunity",
  //       type: "collapsible", // Expandable item with children
  //       icon: "help-circle",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "ganatak",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "ganatakCommunity-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.root",
  //       translate: "MENU.DASHBOARD.root",
  //       type: "collapsible", // Expandable item with children
  //       icon: "paperclip",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "root",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageRoot-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.seed",
  //       translate: "MENU.DASHBOARD.seed",
  //       type: "collapsible", // Expandable item with children
  //       icon: "check-square",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "seed",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageSeed-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.soil",
  //       translate: "MENU.DASHBOARD.soil",
  //       type: "collapsible", // Expandable item with children
  //       icon: "file-text",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "soil",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageSoil-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "language.stem",
  //       translate: "MENU.DASHBOARD.stem",
  //       type: "collapsible", // Expandable item with children
  //       icon: "bookmark",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "stem",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageStem-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Paperform",
  //       translate: "MENU.DASHBOARD.Paperform",
  //       type: "collapsible", // Expandable item with children
  //       icon: "book",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "paperform",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "paperForm-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Sizes",
  //       translate: "MENU.DASHBOARD.Sizes",
  //       type: "collapsible", // Expandable item with children
  //       icon: "book-open",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "sizes",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "sizes-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Language.counselorspayment",
  //       translate: "MENU.DASHBOARD.counselorspayment",
  //       type: "collapsible", // Expandable item with children
  //       icon: "bar-chart-2",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "counselorPayment",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "languageConsulers-add",
  //         },
  //       ],
  //     },
  //     {
  //       id: "terms-and-conditions",
  //       title: "Sliders",
  //       translate: "MENU.DASHBOARD.Sliders",
  //       type: "collapsible", // Expandable item with children
  //       icon: "sliders",
  //       children: [
  //         {
  //           id: "avatars-list",
  //           title: "List",
  //           translate: "MENU.DASHBOARD.list",
  //           type: "item",
  //           icon: "circle",
  //           url: "sliders",
  //         },
  //         {
  //           id: "avatars-add",
  //           title: "Add",
  //           translate: "MENU.DASHBOARD.add",
  //           type: "item",
  //           icon: "circle",
  //           url: "sliders-add",
  //         },
  //       ],
  //     },


  //   ],
  // },
 


    
]
